var render = function (_h,_vm) {var _c=_vm._c;return _c('footer',{staticClass:"bg-purple-900 text-white p-4 text-sm flex justify-center border-t"})}
var staticRenderFns = []

export { render, staticRenderFns }